/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import { RouteComponentProps } from "react-router";
import { useAppDownloadContext } from "../../../../Basis/Components/AppDownloadContext";
import CommandBar from "../../../../Basis/Components/CommandBar";
import CommandBarButton from "../../../../Basis/Components/CommandBarButton";
import Fieldset from "../../../../Basis/Components/Fieldset";
import FieldsetGroup from "../../../../Basis/Components/FieldsetGroup";
import InnerView from "../../../../Basis/Components/InnerView";
import TextInput from "../../../../Basis/Components/TextInput";
import ViewMainContent from "../../../../Basis/Components/ViewMainContent";
import { DownloadIcon } from "../../../../Basis/FontAwesome";
import useQuery from "../../../../Basis/Utils/useQuery";
import StripeClient from "../../Api/StripeClient";
import { belegstatusTranslationKeysMap, translationKeys, useTranslation } from "../../Internationalisierung/i18nMandanten";
import Belegart from "../../Queries/Belegart";
import LadeGutschriftZuMandant from "../../Queries/LadeGutschriftZuMandant";
import LadeRechnungZuMandant from "../../Queries/LadeRechnungZuMandant";
import MandantBelegUtil from "../../Utils/MandantBelegUtil";

export type MandantBelegDetailsViewProps = RouteComponentProps<{
    belegId: string,
    belegart: Belegart,
}>;

export default function MandantBelegDetailsView(props: MandantBelegDetailsViewProps) {
    const { t, tValue } = useTranslation();
    const appDownloadContext = useAppDownloadContext();
    const stripeClient = new StripeClient();
    const { map, state } = props.match.params.belegart === "RECHNUNG" ?
        useQuery({
            query: LadeRechnungZuMandant,
            input: { rechnungId: props.match.params.belegId },
        }) :
        useQuery({
            query: LadeGutschriftZuMandant,
            input: { gutschriftId: props.match.params.belegId },
        });

    async function downloadPdf() {
        await MandantBelegUtil.downloadPdf(
            stripeClient,
            appDownloadContext,
            props.match.params.belegart,
            props.match.params.belegId);
    }

    return (
        <InnerView>
            <CommandBar
                items={[
                    <CommandBarButton
                        icon={<DownloadIcon />}
                        caption={t(translationKeys.mandantBelegDetailsView.herunterladen)}
                        onClick={downloadPdf}
                    />,
                ]}
            />

            <ViewMainContent loading={state.loading}>
                {map(rechnung => (
                    <>
                        <FieldsetGroup>
                            <Fieldset caption={t(translationKeys.mandantBelegDetailsView.details)}>
                                <TextInput
                                    caption={t(translationKeys.mandantBelegDetailsView.nummer)}
                                    value={rechnung.nummer}
                                    feldBezeichnung={""}
                                    typBezeichnung={""}
                                    readonly
                                />
                                <TextInput
                                    caption={t(translationKeys.mandantBelegDetailsView.datum)}
                                    value={tValue(rechnung.datum, "DateTime")}
                                    feldBezeichnung={""}
                                    typBezeichnung={""}
                                    readonly
                                />
                                <TextInput
                                    caption={t(translationKeys.mandantBelegDetailsView.preis)}
                                    value={tValue(rechnung.betrag, "Preis")}
                                    feldBezeichnung={""}
                                    typBezeichnung={""}
                                    readonly
                                />
                                <TextInput
                                    caption={t(translationKeys.mandantBelegDetailsView.status)}
                                    value={t(belegstatusTranslationKeysMap[rechnung.status])}
                                    feldBezeichnung={""}
                                    typBezeichnung={""}
                                    readonly
                                />
                            </Fieldset>
                        </FieldsetGroup>
                    </>
                ))}
            </ViewMainContent>
        </InnerView>
    )
}